<div
  class="product-request-item"
  [class.tui-skeleton]="loading"
  [class.tui-skeleton_rounded]="loading"
  [class.product-request-item_archive]="item?.status === 2"
>
  <div class="product-request-item__info">
    <app-link class="request-name text_bold" [displayText]="item?.name" (click)="onSelectItem.emit()"></app-link>

    <div class="request-date">
      {{
        'components.lpProductRequest.labels.createDate'
          | translate : { value: item?.createdDate | date : 'dd MMMM' : undefined : currentLang }
      }}
    </div>
  </div>

  <div *ngIf="item?.status" class="product-request-item__status">
    {{ item?.status | getStatusText }}
  </div>
</div>
